export const START_EXPERIMENT = 'START_EXPERIMENT'

export const startExperiment = (label, ref, id) => {
    return {type: START_EXPERIMENT, payload: { label, ref, id } }
}



// WEBPACK FOOTER //
// ./src/actions/experiments.js